/**
 * AuthLayout
 */
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Copyright from '../../components/Copyright';
import pellaLogo from '../../assets/pella_logo.png';

const styles = {
  logo: {
    width: '100px',
    margin: '40px auto',
    display: 'block',
  },
  backgroundColor: {
    backgroundColor: '#fafafa',
  },
  footer: {
    height: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '64px',
  },
};
export default function AuthLayout({ children, title }) {
  return (
    <Container component="main" maxWidth="sm" sx={styles.backgroundColor}>
      <img src={pellaLogo} title="Pella Logo" alt="Pella Logo" style={styles.logo} />
      <CssBaseline />
      <Paper sx={{ padding: '20px 40px' }}>
        <Typography component="h1" align="center" variant="h5" color="primary">
          {title}
        </Typography>
        {children}
      </Paper>
      {title !== 'Reset Password' && (
        <Container sx={styles.footer}>
          <Copyright />
        </Container>
      )}
    </Container>
  );
}

// Prop validation
AuthLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};
